import React from "react";
import styles from "./Press.module.scss";

const pressItems = [
  {
    title: "VOGUE World Taiwan",
    link: "https://www.vogue.com.tw/article/mansion0613",
  },
  {
    title: "OBSERVADOR",
    link: "https://observador.pt/2022/01/26/ceramica-cortica-joalharia-e-flores-8-lojas-novas-para-conhecer-no-porto/",
  },
  {
    title: "VISÃO Magazine",
    link: "https://visao.pt/visaose7e/2022-02-22-ha-novas-lojas-no-quarteirao-de-bombarda-no-porto/",
  },
];

const alltitlesAndLinks = [
  {
    title: "VOGUE World Taiwan",
    link: "https://www.vogue.com.tw/article/mansion0613",
  },
  {
    title: "MONOCLE HandBook",
    link: "No link",
  },
  {
    title: "OBSERVADOR",
    link: "https://observador.pt/2022/01/26/ceramica-cortica-joalharia-e-flores-8-lojas-novas-para-conhecer-no-porto/",
  },
  {
    title: "VISÃO Magazine",
    link: "https://visao.pt/visaose7e/2022-02-22-ha-novas-lojas-no-quarteirao-de-bombarda-no-porto/",
  },
  {
    title: "EVASÕES",
    link: "No link",
  },
  {
    title: "ELLE Decoration",
    link: "No link",
  },
  {
    title: "CORKWAY",
    link: "No link",
  },
  {
    title: "PÙBLICO P2 Magazine",
    link: "No link",
  },
  {
    title: "MOBELL Trends",
    link: "No link",
  },
];

function Press() {
  return (
    <div className={styles.faqContainer}>
      <p className={styles.faqTitle}>Press</p>
      {pressItems.map((tl, index) => {
        const hasLink = tl.link !== "No link";
        const QuestionComponent = hasLink ? "a" : "div";
        return (
          <div key={index} className={styles.faqItem}>
            <QuestionComponent
              className={`${styles.faqQuestion} ${hasLink ? styles.clickable : ""}`}
              {...(hasLink
                ? {
                    href: tl.link,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  }
                : {})}
            >
              {tl.title}
            </QuestionComponent>
          </div>
        );
      })}
    </div>
  );
}

export default Press;